module.exports = __webpack_public_path__ + "static/media/043.f872b1bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/043.jpg
// module id = 388
// module chunks = 0